document.addEventListener("DOMContentLoaded", function () {
  const tabContents = document.querySelectorAll(".tabs-stage .tab_contents")
  const firstTabContent = document.querySelector(".tabs-stage .tab_contents")
  const firstTabNav = document.querySelector(".tabs-nav li")
  const tabNavLinks = document.querySelectorAll(".tabs-nav a")

  if (tabContents.length > 0) {
    tabContents.forEach((div) => (div.style.display = "none"))
    if (firstTabContent) firstTabContent.style.display = "block"
  }
  if (firstTabNav) firstTabNav.classList.add("tab-active")
  tabNavLinks.forEach((anchor) => {
    anchor.addEventListener("click", function (event) {
      event.preventDefault()
      document
        .querySelectorAll(".tabs-nav li")
        .forEach((li) => li.classList.remove("tab-active"))
      this.parentElement.classList.add("tab-active")
      tabContents.forEach((div) => (div.style.display = "none"))
      const target = document.querySelector(this.getAttribute("href"))
      if (target) target.style.display = "block"
    })
  })
})
